


































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import FileUpload from "vue-upload-component";
import { Config } from "@/shared/config";

@Component ({
  components: {
    FileUpload
  }
})
export default class EvidenceUpload extends Vue {
  files = [];
  uploadErrors = [];
  inputFilter (newFile, oldFile, prevent) {
    this.clearErrors();
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      if (!/\.(jpeg|jpg|gif|png|bmp|pdf)$/i.test(newFile.name)) {
        this.uploadErrors.push("File type not allowed");
        return prevent();
      }
      const tenMB = 1024 * 1024 * 10;
      if (newFile.size > tenMB) {
         this.uploadErrors.push("File must be smaller than 10 MB");
        return prevent();
      }
    }
  }

  updateFiles (files) {
    const mappedFiles = files.map(f => f.file);
    this.$emit("onFiles", mappedFiles);
  }

  deleteFile (file) {
    const uploadComponent: any = this.$refs.upload;
    uploadComponent.remove(file);
  }

  clearErrors () {
    this.uploadErrors = [];
  }
}
